export default __webpack_public_path__ + "static/media/Snd_CG.78335702.mp3";